import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";

/**
 * 🔹 Payload para crear/actualizar
 */
export interface AsignaResponsabilidadCargoPayload {
  id_responsabilidad: number;
  id_cargo: number;
  estado?: number;
}

/**
 * 🔹 Interface de respuesta
 */
export interface AsignaResponsabilidadCargo {
  id?: number;
  id_responsabilidad: number;
  id_cargo: number;
  estado: number;
  fechaCreacion?: string;
  fechaModificacion?: string | null;
}

export interface AsignaResponsabilidadCargoResponse {
  id?: number;
  message?: string;
  error?: string;
  data?: any;
  [key: string]: any;
}

@Injectable({
  providedIn: "root",
})
export class AsignaResponsabilidadCargoService {
  private readonly apiUrl = `${environment.apiUrl}/api/asigna_responsabilidad_cargo`;

  constructor(private http: HttpClient) {}

  // Listar todas las asignaciones
  getAll(): Observable<AsignaResponsabilidadCargo[]> {
    return this.http.get<AsignaResponsabilidadCargo[]>(this.apiUrl, { withCredentials: true });
  }

  // Obtener por ID
  getById(id: number): Observable<AsignaResponsabilidadCargo> {
    return this.http.get<AsignaResponsabilidadCargo>(`${this.apiUrl}/${id}`, { withCredentials: true });
  }

  // Crear nueva asignación
  create(payload: AsignaResponsabilidadCargoPayload): Observable<AsignaResponsabilidadCargoResponse> {
    return this.http.post<AsignaResponsabilidadCargoResponse>(this.apiUrl, payload, { withCredentials: true });
  }

  // Actualizar asignación
  update(id: number, payload: Partial<AsignaResponsabilidadCargoPayload>): Observable<AsignaResponsabilidadCargoResponse> {
    return this.http.put<AsignaResponsabilidadCargoResponse>(`${this.apiUrl}/${id}`, payload, { withCredentials: true });
  }

  // Eliminar asignación (DELETE)
  remove(id: number): Observable<any> {
    return this.http.delete<any>(`${this.apiUrl}/${id}`, { withCredentials: true });
  }

  // Inactivar asignación
  inactivar(id: number): Observable<AsignaResponsabilidadCargoResponse> {
    return this.http.put<AsignaResponsabilidadCargoResponse>(`${this.apiUrl}/${id}/inactivar`, {}, { withCredentials: true });
  }

  // Activar asignación
  activar(id: number): Observable<AsignaResponsabilidadCargoResponse> {
    return this.http.put<AsignaResponsabilidadCargoResponse>(`${this.apiUrl}/${id}/activar`, {}, { withCredentials: true });
  }
}